<script setup lang="ts">
/**
 * リプライ情報 > バッジ表示。
 */
import { defineProps } from "vue";
import BadgeTypeUtil from "@/modules/utils/badgeTypeUtil";

interface Props {
	/**
	 * バッジ種別。
	 */
	badgeType: string | null;
}
const props = defineProps<Props>();

/**
 * バッジが存在するかどうかを返却。
 * バッジがないのであれば表示しない。
 */
const isExistBadge = (): boolean => {
	if (props.badgeType === null) {
		return false;
	}
	return true;
};

/**
 * バッジ形式が公式ファンかどうか取得。
 */
const isOfficialFan = (): boolean => {
	return BadgeTypeUtil.isOfficialFan(props.badgeType);
};
/**
 * バッジ形式がスタッフかどうか取得。
 */
const isStaff = (): boolean => {
	return BadgeTypeUtil.isStaff(props.badgeType);
};
</script>

<template>
	<div class="revico-community-talk-reply-details-badge" v-if="isExistBadge()">
		<!-- バッジによって表示を分岐 -->
		<div v-if="isOfficialFan()" class="revico-community-talk-reply-details-badge-official-fan">Official <br />Fan</div>
		<div v-if="isStaff()" class="revico-community-talk-reply-details-badge-staff">Staff</div>
	</div>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	.revico-community-talk-reply-details-badge {
		width: 52px;
		height: 52px;
		margin: -8px 0 0 -8px;
		font-size: 0.6em;
		text-align: center;
		border: 3px solid #fff;
		border-radius: 100%;

		&-official-fan,
		&-staff {
			width: 40px;
			height: 40px;
			margin: 3px 0 0 3px;
			padding: 4px 0 0 0;
			color: #666;
			font-weight: bold;
			background-color: #fff;
			border: 2px solid transparent;
			border-radius: 100%;
		}
	}
}
</style>
